import { render, staticRenderFns } from "./Third1.vue?vue&type=template&id=072e05a4&scoped=true"
import script from "./Third1.vue?vue&type=script&lang=js"
export * from "./Third1.vue?vue&type=script&lang=js"
import style0 from "./Third1.vue?vue&type=style&index=0&id=072e05a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e05a4",
  null
  
)

export default component.exports